import ReactDOM from 'react-dom/client';
//
import App from './App';
import './index.css';

function silenceStaleCachePutErrors() {
  if (process.env.NODE_ENV === 'production' || typeof window === 'undefined') {
    return;
  }

  window.addEventListener('unhandledrejection', (event) => {
    const message = String(event.reason?.message || event.reason || '');

    if (message.includes("Failed to execute 'put' on 'Cache'")) {
      event.preventDefault();
    }
  });
}

function clearStaleServiceWorkerState() {
  if (typeof window === 'undefined') {
    return;
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(registrations.map((registration) => registration.unregister()))
      )
      .then(() => {
        if (navigator.serviceWorker.controller && !sessionStorage.getItem('rf-sw-cache-reset')) {
          sessionStorage.setItem('rf-sw-cache-reset', '1');
          window.location.reload();
        }
      })
      .catch(() => {});
  }

  if ('caches' in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch(() => {});
  }
}

silenceStaleCachePutErrors();
clearStaleServiceWorkerState();

// Lazy load non-critical modules
const loadNonCritical = () => {
  // Load service worker registration after app has loaded
  import('./serviceWorkerRegistration').then(({ unregister }) => {
    unregister();
  });
  
  // Load web vitals reporting after app has loaded  
  import('./reportWebVitals').then(({ default: reportWebVitals }) => {
    reportWebVitals();
  });
};

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// Defer non-critical loading until after initial render
setTimeout(loadNonCritical, 100);
